import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { detectLocale, loadLocale } from './i18n';

await loadLocale(detectLocale());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
